import { Box } from '@mui/material';
import Loader from 'components/Loader/Loader';
import TableMonitoring from 'components/TableMonitoring';
import NoDataTableBody from 'components/TableMonitoring/Body/NoDataTableBody';
import EditMenuOption from 'components/TableMonitoring/Body/RowMenuListActions/EditMenuOption';
import TableRowStatic from 'components/TableMonitoring/Body/TableRowStatic';
import TableHeaderStatic from 'components/TableMonitoring/Header/Static/TableHeaderStatic';
import { packagesTexts } from 'locale/es';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import DrawerHeader from 'components/DrawerHeader';
import BreadCrumbs from 'components/Breadcrumbs/Breadcrumbs';
import AppsIcon from '@mui/icons-material/Apps';
import { initializeBusinessPackage } from 'redux/reducers/packagesReducer';
import { useFilter } from 'hooks/useFilter';
import { useFilterContext } from 'context/FilterContext';
import { PackageTableRows } from './PackagesTableRows';
import FilterTable from 'components/TableMonitoring/Toolbar/Filter';

const tableHeaders = [
  { name: packagesTexts.NAME, value: 'name' },
  { name: packagesTexts.STATUS, value: 'status' },
  { name: packagesTexts.WIZARD, value: 'wizards' },
  { name: packagesTexts.PHYSICALACTIVITY, value: 'physicalActivityType' },
];

export function PackagesTable() {
  const { data, loading, error } = useSelector(
    ({ businessPackage }) => businessPackage
  );
  const { selectedFilter, searchTerm } = useFilterContext();

  const dispatch = useDispatch();

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  useEffect(() => {
    dispatch(initializeBusinessPackage());
  }, [dispatch]);

  if (loading) {
    return <Loader message={packagesTexts.LOADER} pt={32} />;
  }

  if (!data) return null

  return (
    <Box component='main' sx={{ flex: 1, p: 3, mb: 20 }}>
      <DrawerHeader />
      <BreadCrumbs
        name={packagesTexts.BREADCRUMBS}
        icon={<AppsIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
      />
      <Box mt={4} sx={{ minWidth: '100%' }}>
        <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              entity={data}
              canCreate
            />
          }
        >
          {(selectedFilter && !searchTerm ? data : filteredData).map(
            (intervention) => (
              <TableRowStatic
                key={intervention.id}
                entity={intervention}
                loaded={!loading}
                actions={
                  <Box>
                    <EditMenuOption entity={intervention} />
                    {/* <DeleteMenuOption entityId={intervention.id} /> */}
                  </Box>
                }
              >
                <PackageTableRows intervention={intervention} />
              </TableRowStatic>
            )
          )}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            selectedEntity={true} // ? Is this necessary?
            noDataMessage={packagesTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={data}
            noDataMessage={packagesTexts.NO_DATA_FILTERS}
          />
        )}
      </Box>
      <Outlet />
    </Box>
  );
}
